import { CredentialsProvider, makeCredentialsGetter } from "src/neuroglancer/credentials_provider";
import { Credentials } from "../ngauth/credentials_provider";
import { message } from "src/neuroglancer/widget/message";
import { HttpError, displayLoadingNone, noPermision } from "src/neuroglancer/util/http_request";
import { interceptorHeaderInfo, headerMap } from "neuroglancer/util/http_interceptors_base";
// const login_url = {'stomics+sap': 'https://www.baidu.com'}
export class StomicsPrecomputedCredentialsProvider extends CredentialsProvider<Credentials> {
  constructor(public serverUrl: {protocol: string, host: string, path: string}) {
    super();
  }
  get = makeCredentialsGetter(async () => {
    const m = this.serverUrl.path.split('/');
    const local_path = [m[0], m[1], m[2], m[3], m[4]];
    let response = await fetch(`${this.serverUrl.protocol.includes('https') ? 'https':'http'}://${this.serverUrl.host}${local_path.join('/')}/get_session_id`);
    switch (response.status) {
      case 200:
        // console.log(await response)
        const res = JSON.parse(await response.text())
        localStorage.setItem('skfx_session', res.data.id);
        interceptorHeaderInfo.value[headerMap['skfx_session']] = res.data.id;
        return {token: res.data.id};
      case 401:
        displayLoadingNone();
        noPermision();
        displayLoadingNone();
        noPermision();
        // const login = this.serverUrl.protocol.replace(/(\+http|\+https)/, '');
        // self.location.href = login_url[login]
      case 403:
        // throw makeOriginError(this.serverUrl);
      case 500:
        if(!response.url.includes('-') || !response.url.includes('_')){
          new message(`${response.statusText}`,'error');
        }
      case 400:
        displayLoadingNone();
        noPermision();
        new message(`${response.statusText}`,'error');
      default:
        throw HttpError.fromResponse(response);
    }
  });
}